import { render } from "./faq-section.vue?vue&type=template&id=086a3344"
import script from "./faq-section.vue?vue&type=script&lang=js"
export * from "./faq-section.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__